import { ISMT_ChuDe_DeThiIn } from "../../../model/respone/de-thi/ISMT_ChuDe_DeThiIn";
import { apiClient } from "../../apiClient";

export const CHU_DE_THI_IN_ENDPOINT = "chu-de-thi-in";
export const chuDeThiInApi = {
  Select: (payload: ISMT_ChuDe_DeThiIn) =>
    apiClient.get(`${CHU_DE_THI_IN_ENDPOINT}`),
  SelectByIdNhom: (id_nhomdethiin: number) =>
    apiClient.get(
      `${CHU_DE_THI_IN_ENDPOINT}/select-vm/nhom-de-thi/${id_nhomdethiin}`
    ),
  SelectById: (id: number) => apiClient.get(`${CHU_DE_THI_IN_ENDPOINT}/${id}`),
  Insert: (payload: ISMT_ChuDe_DeThiIn) =>
    apiClient.post(`${CHU_DE_THI_IN_ENDPOINT}`, payload),
  Update: (payload: ISMT_ChuDe_DeThiIn) =>
    apiClient.put(`${CHU_DE_THI_IN_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${CHU_DE_THI_IN_ENDPOINT}/${id}`),
  DeleteMultiple: (ids: number[]) =>
    apiClient.put(`${CHU_DE_THI_IN_ENDPOINT}/delete-multiple`, ids),
};
